<template>
  <div style="margin: 0 40px;">
    <el-form size="small" style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="140px" class="demo-ruleForm old-person">
      <el-form-item :label="item.s_name + '：'" prop="" v-for="(item, index) in eserviceArr" :key="index">
        <el-checkbox-group v-model="item.selectSubItem">
          <el-checkbox v-for="subItem in item.subItems" :label="subItem" :key="subItem">{{subItem}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  queryeservicelist,
  queryeservicepersonsetinglist,
  updateeservicepersonseting
} from '../../../api/yanglaoyuan/eservice'

export default {
  name: 'setEService',
  model: {
    prop: 'setEServiceShow',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      row: '',
      eserviceArr: [],

      addEditForm: {},
      addEditRules: {}
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname
      this.row = this.listObj.row

      this.getEserviceListData()
    },

    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendSet()
        }
      })
    },
    sendSet () {
      let eServices = []
      this.eserviceArr.forEach(item => {
        if (item.selectSubItem.length !== 0) {
          let selectItems = ''
          item.selectSubItem.forEach(subItem => {
            if (selectItems.length !== 0) {
              selectItems += '|'
            }
            selectItems += subItem
          })
          let obj = {
            s_id: item.s_id,
            select_items: selectItems
          }
          eServices.push(obj)
        }
      })
      let data = {
        eid: this.eId,
        pid: this.row.epid,
        cin_id: this.row.id,
        esp_id: this.espId,
        esp_name: this.espName,
        arr: eServices.length !== 0 ? eServices : null
      }
      updateeservicepersonseting(data).then(res => {
        this.$notify({title: '成功', message: '成功设置护理项目', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    // 访问接口
    // 获取护理项目
    getEserviceListData () {
      let that = this
      this.eserviceArr = []
      let params = {}
      let data = {
        eid: this.eId
      }
      queryeservicelist(params, data).then(res => {
        let arrData = res.data.arrdata
        arrData.forEach(item => {
          if (item.sub_items && item.sub_items.length !== 0) {
            item.subItems = item.sub_items.split('|')
          } else {
            item.subItems = []
          }
          item.selectSubItem = []
          that.eserviceArr.push(item)
        })
        this.getEServicePersonSetingListData()
      })
    },
    // 获取入住的个人护理项目
    getEServicePersonSetingListData () {
      let that = this
      let params = {}
      let data = {
        eid: this.eId,
        id1: this.row.epid
      }
      queryeservicepersonsetinglist(params, data).then(res => {
        let arrData = res.data.arrdata
        arrData.forEach(item => {
          let eService = that.eserviceArr.find(r => r.s_id === item.s_id)
          if (eService) {
            let selectSubItem = item.select_items.split('|')
            eService.selectSubItem = selectSubItem
            selectSubItem.forEach(subItem => {
              if (subItem !== '' && !eService.subItems.find(r => r === subItem)) {
                eService.subItems.push(subItem)
              }
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/setEService.vue